// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging,getToken } from "firebase/messaging";
import { getPerformance } from 'firebase/performance';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

// 🔥 App Check configuration based on environment
if (typeof window !== 'undefined') {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';

  if (isDevelopment || isLocalhost) {
    // 🔥 Use debug token for development/localhost
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  } else {
    // 🔥 Use reCAPTCHA for production
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
  }
}

export const messaging = getMessaging(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const perf = getPerformance(app);

/**
 * Generate Firebase Cloud Messaging token.
 * @returns {Promise<string | null>} FCM token or null if an error occurs.
 */

export const generateToken = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          process.env.REACT_APP_FIREBASE_VAPID_KEY
      });
      if (token) {
        return token;
      }
    } else {
      alert(
        "Notifications are currently disabled. Open your browser settings and enable notifications for proper functionality."
      );
    }
    console.error("Notification permission not granted.");
    return null;
  } catch (error) {
    console.error("Error generating FCM token:", error);
    return null;
  }
};
